import { useEffect, useState } from 'react';

const FALLBACK_DELAY_MS = 300;

/**
 * Suspense fallback wrapper that waits before rendering its children.
 * Avoids flashing a loading indicator when the suspended content resolves quickly.
 */
export default function DelayedFallback({ children }) {
    const [showFallback, setShowFallback] = useState(false);

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setShowFallback(true);
        }, FALLBACK_DELAY_MS);

        return () => {
            clearTimeout(timeoutId);
        };
    }, []);

    if (!showFallback) {
        return null;
    }

    return children;
}
